import React, { useState, useMemo, useEffect, useContext, useRef } from "react";
import {  useParams, Link, useLocation, matchPath } from 'react-router-dom';
import moment from "moment";
import NewLogo from "../NewLogo";
import RandomLogo from "../RandomLogo";
import DataTable from '../../Components/DataTables/DataTable';
import ExcelDownloader from "../shared/ExcelDownloader";
import { exportExcel, exportPDF, getSimilarCompanyUrl } from "../../Config/config";
import routePathSegments, { routeNames } from '../../routeSegments';
import axios from "axios";
import { UserContext } from "../../Contexts/UserContext";
import Constants from "../../Constants";
import useModule from "../../hooks/useModule";
import OverflowToolTip from '../shared/OverflowToolTip';
import { DataFoundContext } from "../../Contexts/DataFoundContext";
import { PeFilterContext } from "../../Contexts/PeFilterContext";


/**
 * The `SimilarCompanies` function is a React component that displays a table of similar companies
 * based on a given company name.
 */
const SimilarCompanies = ({ companyName, data, menu, cmpIds }) => {
    console.log(companyName, "companyName")
    const SimilarCosRef = useRef(null);

    const [similarCompanies] = useState(data);
    const [showXlDownload, setshowXlDownload] = useState(false);
    const [fileName, setFileName] = useState("");
    const { companyId } = useParams();
    const location = useLocation();
    const {isTrialExport, getToken, isStudent } = useContext(UserContext);
    const { monthPickerValue, accessControl } = useContext(PeFilterContext);
    const{primaryMasterId}=useModule();
    const [bodyForExport, setBodyForExport] = useState({
    "Export_from": "list",
    "with_deals": true,
    "with_transaction": true,
    "is_refine": true,
    "type": menu === "vc" ? "vc_investment" : "pe_vc_investment",
    "company_id": cmpIds,
    "deal_ids": [],
    "module_type": menu === "vc" ? "vc" : "pe",
    "with_agg_hide": 0,
    "profile_columns": [
        "ALL"
    ],
    "inv_deal_columns": [
        "Company Name",
        "Registered Entity Name",
        "Industry",
        "Sector",
        "CIN",
        "Location",
        "Website",
        "Company Type",
        "Contact",
        "Amount(US$M)",
        "Amount(INR Cr)",
        "Exit Status",
        "Date",
        "Stake (%)",
        "Stage",
        "Round",
        "Round(By Series)",
        "Link",
        "Price Per Share",
        "Book Value Per Share",
        "Price to Book",
        "Equity/Debt",
        "Valuation",
        "Year Founded",
        "Pre Money Valuation (INR Cr)",
        "Revenue Multiple (Pre)",
        "EBITDA Multiple (Pre)",
        "PAT Multiple (Pre)",
        "Post Money Valuation (INR Cr)",
        "Revenue Multiple (Post)",
        "EBITDA Multiple (Post)",
        "PAT Multiple (Post)",
        "Enterprise Valuation (INR Cr)",
        "Revenue Multiple (EV)",
        "EBITDA Multiple (EV)",
        "PAT Multiple (EV)",
        "Investors",
        "Investor Type",
        " Financial Year",
        "Revenue (INR Cr)",
        "EBITDA (INR Cr)",
        "PAT (INR Cr)",
        "Total Debt (INR Cr)",
        "Cash & Cash Equ. (INR Cr)",
        "Advisor-Company",
        "Advisor-Investors",
        "More Info"
    ],
    "transaction_category": [
        "investments",
        "exits",
        "ipos",
        "angel",
        "incubationEntity Name",
        "Industry",
        "Sector_Business Description",
        "CIN",
        "Location",
        "Website",
        "Company Type",
        "Deal Amount (US$M)",
        "Exit Status",
        "Deal Date",
        "Acquirer",
        "Stake Sold(%)",
        "Deal Type",
        "Type",
        "Link",
        "Price Per Share",
        "Book Value Per Share",
        "Price to Book",
        "Exiting Investors",
        "Return Multiple",
        "IRR (%)",
        "Company Valuation (INR Cr)",
        "Revenue Multiple",
        "EBITDA Multiple",
        "PAT Multiple",
        "Valuation (More Info)",
        "Investment Details",
        "Addln Info",
        "More Info(Returns)",
        "Revenue (INR Cr)",
        "EBITDA (INR Cr)",
        "PAT (INR Cr)",
        "Advisor-Buyer",
        "Advisor-Seller",
        "Year Founded",
        "Investor Type"
    ],
    "ipo_deal_columns": ["ALL"],
    "angel_deal_columns": ["ALL"],
    "incb_deal_columns": ["ALL"],
    "date_range": {
        "from_date": "1998-07-01",
        "to_date": moment(monthPickerValue[1]).format("YYYY-MM-DD")
    },
    stage_names: accessControl?.pe_stage?.name,
    deal_range: {
        from: accessControl?.pe_deal_range?.from,
        to: accessControl?.pe_deal_range?.to,
        currency: accessControl?.pe_deal_range?.currency,
    }
})

    const peMatch = matchPath(`${routePathSegments.pe}/*`, location.pathname);
    const vcMatch = matchPath(`${routePathSegments.vc}/*`, location.pathname);
    const cfsMatch = matchPath(`${routePathSegments.cfs}/*`, location.pathname);

    const customStringSortMemo = useMemo(() => {
        return (rowA, rowB, columnId, desc) => {
            const defaultVal = desc ? '--' : 'A';
            return (rowA?.values[columnId]?.name ?? defaultVal).localeCompare(rowB?.values[columnId]?.name ?? defaultVal);
        }
    }, []);

    const customSectorSortMemo = useMemo(() => {
        return (rowA, rowB, columnId, desc) => {
            const defaultVal = desc ? '--' : 'A';
            return (rowA?.values[columnId]?.sector ?? defaultVal).localeCompare(rowB?.values[columnId]?.sector ?? defaultVal);
        }
    }, []);


    /* The `dealDateSort` constant is a custom sorting function that is used to sort the data in the
    "Latest Deal Date" column of the table. */
    const dealDateSort = useMemo(() => {
        return (rowA, rowB, columnId, desc) => {
            return moment.utc(rowA?.values[columnId].date).diff(moment.utc(rowB?.values[columnId].date))
        }
    }, [])

    const addCommasToNumber = (number) => {
        return number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      };

    const cfsColumns = useMemo(() => [
        {
            id: "short_name",
            Header: "Company Name",
            accessor: "short_name",
            className: "clickable w-[20%] text-left sticky left-0 lg:relative bg-white",
            headerClassName: "text-left sticky left-0 lg:relative w-[3rem] bg-[#EDEDED] ",
            Cell: ({ value }) => (
                <div className="flex gap-2">
                    <span className="leading-[1.8rem] lg:leading-[2rem] font-sans_book_body items-center justify-center">
                        <NewLogo id={value.id} name={value.name} page="company page" />
                        <OverflowToolTip className="w-[10rem]" component={
                            <Link
                            className="flex text-start lg:inline leading-[1.8rem] hover:text-[#BC8B20] text-[#333333]"
                            to={routeNames.cfsCompanyPageById(value?.id)}>
                                {value.name ?? "--"}
                            </Link>
                        } />
                    </span>
                    {/* Rank badge parked for now: `rank` is just the API's array position
                    (rowData sets it as i+1), so it reads as a similarity rank it does not
                    actually carry. Restore once the backend sends a real rank. */}
                    {/* <span className="flex items-center rounded-md bg-[#f3e8ff] px-2 py-[3px] ml-2 text-xs font-sans_book_body text-[#3939ab]">{value.rank}</span> */}
                </div>
            ),
            sortType: customStringSortMemo,
        },
        // {
        //     Header: "Full Name",
        //     accessor: "full_name",
        //     className: "w-[25%]",
        //     Cell: ({ value }) => (
        //         <OverflowToolTip className="w-[18rem]" component={value ?? "--"} />
        //     ),
        // },
        {
            Header: "Sector",
            accessor: "sector",
            className: "w-[15%]",
            Cell: ({ value }) => (
                <div>{value.sector}</div>
            ),
        },
        {
            Header: "City",
            accessor: "city",
            className: "w-[10%]",
        },
        {
            Header: "FY",
            accessor: "fy",
            className: "w-[10%]",
            Cell: ({ value }) => (
                <span>{value ?? "--"}</span>
            ),
        },
        {
            Header: "Std. Revenue",
            accessor: "revenue",
            className: "w-[12%]",
            Cell: ({ value }) => (
            // <span>{value ?? "--"}</span>
            <span>{value && value !== "--" ? (value / 10000000).toFixed(2) : "--"}</span>
            ),
        },
        {
            Header: "Std. EBITDA",
            accessor: "ebitda",
            className: "w-[12%]",
            Cell: ({ value }) => (
            // <span>{value ?? "--"}</span>
            <span>{value && value !== "--" ? (value / 10000000).toFixed(2) : "--"}</span>
            ),
        },
        {
            Header: "Std. PAT",
            accessor: "pat",
            className: "w-[12%]",
            Cell: ({ value }) => (
            // <span>{value ?? "--"}</span>
            <span>{value && value !== "--" ? (value / 10000000).toFixed(2) : "--"}</span>
            ),
        },
        {
            Header: "Transacted Status",
            accessor: "transactedStatus",
            className: "w-[13%]",
            Cell: ({ value }) => (
                <span>{value ?? "--"}</span>
            ),
        },
    ], [customStringSortMemo]);

    const columns = useMemo(() => [
        {
            id: "short_name",
            Header: "Company Name",
            accessor: "short_name", 
            className: "clickable w-[15%] text-left sticky left-0 lg:relative   bg-white",
            headerClassName: "text-left sticky left-0  lg:relative w-[3rem] bg-[#EDEDED] ",
            Cell: ({ value }) => {
                return <span className="leading-[1.8rem] lg:leading-[2rem] font-sans_book_body items-center justify-center">
                    <NewLogo id={value.id} name={value.name} page="company page"/>
                    <OverflowToolTip className="w-[10rem]" component={  <Link
                        className="flex text-start lg:inline leading-[1.8rem] hover:text-[#BC8B20] text-[#333333]"
                        to={menu === 'cfs'
                            ? routeNames.cfsCompanyPageById(value?.id)
                            : peMatch != null
                                ? routeNames.peCompanyFundById(value?.id)
                                : vcMatch != null
                                    ? routeNames.vcCompanyFundById(value?.id)
                                    : routeNames.peCompanyFundById(value?.id)}>
                        {value.name ?? "--"}
                    </Link>}/>
                </span>

            },
            sortType: customStringSortMemo,
        },
        {
            Header: "Sector",
            accessor: "sector",
            className: "w-[12%]",
            Cell: ({value}) => {
                return <span style={{whiteSpace:"break-spaces"}} >
                     <OverflowToolTip className='w-[14rem]' component={ 
                            value.sector
                      }/>
                </span>
                       
                        
                    },
             
                    sortType: customSectorSortMemo,
        },
        {
            Header: "Total Funding (US$ M)",
            accessor: "totalFunding",
            className: "w-[13%]",
            Cell: ({ value }) => (
                <span>{value ?? "--"}</span>
            ),
        },
        {
            Header: "Latest Round",
            accessor: "latestRound",
            className: "w-[12%]",
            Cell: ({ value }) => (
                <span>{value ?? "--"}</span>
            ),
        },
        {
            Header: "Latest Deal Date",
            accessor: "latestDealDate",
            className: "w-[13%]",
            Cell: ({ value }) => (
                <span>{value ?? "--"}</span>
            ),
        },
        {
            Header: "Latest Deal Amount",
            accessor: "latestDealAmount",
            className: "w-[13%]",
            Cell: ({ value }) => (
                <span>{value ?? "--"}</span>
            ),
        },
        {
            Header: "City",
            accessor: "city",
            className: "w-[10%]",

        }
    ], [customStringSortMemo, customSectorSortMemo, menu, peMatch, vcMatch, cfsMatch]);

    const rowData = useMemo(() => {
        const rows = [];                 
        similarCompanies?.forEach((company, i) => {
            rows.push({
                short_name: { id: company?.company_id || company?.id, name: company?.name || company?.short_name || company?.company_name, rank: i+1},
                // full_name: company?.full_name || company?.registered_name || "--",
                sector: { sector: company?.sector },
                totalFunding: company?.total_funding,
                latestRound: company?.latest_investment?.round || company?.round || company?.latest_round,
                latestDealDate: company?.latest_investment?.date || company?.date || company?.latest_deal_date,
                latestDealAmount: company?.latest_investment?.amount || company?.amount || company?.latest_deal_amount,
                city: company?.city !== "Unknown" ? company?.city : "-",
                fy: company?.fy || company?.financial_year || "--",
                revenue: company?.revenue || "--",
                ebitda: company?.ebitda || "--",
                pat: company?.pat || "--",
                transactedStatus: company?.transacted_status || company?.exit_status || "--",
            
            });
        });

        setshowXlDownload(rows.length !== 0);

        return rows;
    }, [similarCompanies]);


    const initialSort = useMemo(() => menu == "cfs" ? [] : [
        {
            id: 'dealDate',
            desc: true
        }
    ], []);

    return (
        <div className="mx-4" ref={SimilarCosRef}>
            <div className="bg-white overflow-hidden sm:rounded-lg shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">
                <div className="pt-4 px-5">
                    <div className="flex justify-between mb-3">
                        <h3 className=" text-[14pt] leading-[19pt] text-[#333333] lg:text-[17px] font-semibold  lg:leading-[22px] ">Similar Companies</h3>
                        { (isTrialExport != 'false' && isStudent == 'false' && showXlDownload) ?
                        menu === 'cfs' ? (
                            <ExcelDownloader
                                url={exportExcel}
                                fileName={fileName}
                                data={{
                                    export_from: "detail", 
                                    module_type: "investments",
                                    section: "similar_companies",
                                    type: 5,
                                    is_detailed: true,
                                    company_id:[companyId] 
                                }}
                            />
                        ) : (
                           <ExcelDownloader
                                url={exportPDF}
                                fileName={Constants.exportNames.similarCompanies(companyName)}
                                data={bodyForExport} />
                        ): <></>}
                    </div>
                </div>
                <div className="space-y-6">
                    <div className="bg-white pb-2 rounded-[6px]">
                        <DataTable columns={menu === 'cfs' ? cfsColumns : columns} data={rowData} sortBy={initialSort} RefValue={SimilarCosRef}/>
                    </div>
                </div>
                {/* CFS similar companies are AI-derived, so the list carries a standing caveat.
                Styled as the Directors "Last Updated on" footnote, under the table it qualifies. */}
                {menu === 'cfs' && (
                    <div className="text-xs text-gray-600 m-2 italic">
                        * Similar companies are identified using AI, so this list may occasionally be inaccurate.
                    </div>
                )}
            </div>
        </div>
    );
};

export default SimilarCompanies;
